import { Helmet } from 'react-helmet-async';
import { TITLES } from '../../types/titles';
import DepositLayout from '../../components/deposit';

const Deposit = () => {
	return (
		<>
			<Helmet>
				<title>{TITLES.DEPOSIT.INDEX}</title>
			</Helmet>
			<DepositLayout />
		</>
	);
};

export default Deposit;
